// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.department-form-container {
  margin-top: 16px;
  width: 50%;
  max-width: 600px;
}

.department-form-hint {
  font-size: 14px;
  color: #718096;
  margin-bottom: 20px;
}

.department-form-loading,
.department-form-empty {
  font-size: 14px;
  color: #718096;
  padding: 16px;
  background: #f7fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.department-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.department-form .form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.department-form .form-group label {
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
}

.department-form .form-group input,
.department-form .form-group select,
.department-form .form-group textarea {
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s;
  outline: none;
  font-family: inherit;
}

.department-form .form-group input:focus,
.department-form .form-group select:focus,
.department-form .form-group textarea:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.department-form .form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.department-form .submit-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 14px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  margin-top: 8px;
}

.department-form .submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
}

.department-form .submit-button:active:not(:disabled) {
  transform: translateY(0);
}

.department-form .submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.department-form-container .message {
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 500;
}

.department-form-container .message.success {
  background-color: #c6f6d5;
  color: #22543d;
  border: 1px solid #9ae6b4;
}

.department-form-container .message.error {
  background-color: #fed7d7;
  color: #742a2a;
  border: 1px solid #fc8181;
}
`, "",{"version":3,"sources":["webpack://./src/components/AddDepartmentForm/AddDepartmentForm.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,oBAAoB;AACtB;;AAEA;;;EAGE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":[".department-form-container {\n  margin-top: 16px;\n  width: 50%;\n  max-width: 600px;\n}\n\n.department-form-hint {\n  font-size: 14px;\n  color: #718096;\n  margin-bottom: 20px;\n}\n\n.department-form-loading,\n.department-form-empty {\n  font-size: 14px;\n  color: #718096;\n  padding: 16px;\n  background: #f7fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.department-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.department-form .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.department-form .form-group label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.department-form .form-group input,\n.department-form .form-group select,\n.department-form .form-group textarea {\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.2s;\n  outline: none;\n  font-family: inherit;\n}\n\n.department-form .form-group input:focus,\n.department-form .form-group select:focus,\n.department-form .form-group textarea:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.department-form .form-group textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.department-form .submit-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 14px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n  margin-top: 8px;\n}\n\n.department-form .submit-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);\n}\n\n.department-form .submit-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.department-form .submit-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.department-form-container .message {\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.department-form-container .message.success {\n  background-color: #c6f6d5;\n  color: #22543d;\n  border: 1px solid #9ae6b4;\n}\n\n.department-form-container .message.error {\n  background-color: #fed7d7;\n  color: #742a2a;\n  border: 1px solid #fc8181;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
